import "./healthcare.scss";
import template from "./healthcare.html";
import {Base} from "../base";
import {Options} from "vue-class-component";
import {Toast} from 'bootstrap';


(window as any).Toast = Toast;

@Options({
	template,
})
export class Healthcare extends Base {
	firstName = '';
	lastName = '';
	email = '';
	company = '';

	formIsValid = false;

	firstNameIsValid = true;
	lastNameIsValid = true;
	emailIsValid = {
		isCorrect: true,
		isFull: true
	}

	/** Lifecycle */
	created() {
		this.init().catch(this.errorHandle);
	}

	/** Methods */
	async init() {
	}

	resetForm() {
		this.firstName = '';
		this.lastName = '';
		this.email = '';
		this.company = '';

		this.formIsValid = true;
		this.firstNameIsValid = true;
		this.lastNameIsValid = true;
		this.emailIsValid = {
			isCorrect: true,
			isFull: true
		}
	}


	checkValidateEmail(str: any) {
		return str.match(
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
	};

	checkFormValid() {
		this.firstNameIsValid = !!this.firstName.trim().length;
		this.lastNameIsValid = !!this.lastName.trim().length;
		this.emailIsValid.isFull = !!this.email.trim().length;
		if (this.emailIsValid.isFull) {
			this.emailIsValid.isCorrect = !!this.checkValidateEmail(this.email.trim());
		}

		this.formIsValid = this.firstNameIsValid &&
			this.lastNameIsValid &&
			this.emailIsValid.isFull &&
			this.emailIsValid.isCorrect;
	}


	async formHandler() {
		try {
			const formData = new FormData();

			formData.append("firstName", this.firstName)
			formData.append("lastName", this.lastName)
			formData.append("email", this.email)
			formData.append("company", this.company)

			this.checkFormValid()

			if (this.formIsValid) {
				const res = await this.$api.post("/api/invite.php", formData);
				new Toast(document.getElementById('toast-email-sent')).show();
				this.resetForm()
			} else {
				new Toast(document.getElementById('toast-email-fail')).show();
			}
		} catch (err) {
			this.errorHandle(err);
		}
	}
}
